import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pcontinue(){
  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
 
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python Continue Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python Continue tutorial for beginners and Python Continue on next line is usually associated with an if,CodeExampler provides Multiple Programming Examples for Beginners" />
<meta name="keywords" content="codeexampler,programming language,Python continue loop,Python continue for loop,Python continue vs break,Python continue break,Python continue while loop,,for loop Python continue,Python continue execution after exception,Python continue in for loop " />
<link rel="canonical" href="https://www.codeexampler.com/python-continue" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Python Continue</h1>

    <div className="first">
        <a href="/python-break">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-lambda">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


    <h2 className="mt-4 mh2">Python Continue on following line:</h2>
<p className="mt-4 para">A Python Continue the following line is usually associated with an if
</p>
  

 <h2 className='headings'>Python Continue Statement Syntax</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">continue</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>   

<h2 className="mt-4 mh2">Python for loop Continue Example:</h2>




<h2 className='headings'>Q-Write a program Python loop start from 1 to 10 and loop again continue at 4?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-7">for</span>
                  <span className="qwerty-4"> i</span>
                  <span className="qwerty-5"> in</span>
                  <span className="qwerty-6"> range</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-2">1</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-2">11</span>
                  <span className="qwerty-1">)</span>
                  <span className="qwerty-1">:</span>
              {"\n"}
              <span className="qwerty-6">    if</span>
                   <span className="qwerty-4"> i</span>
                   <span className="qwerty">==</span>
                   <span className="qwerty-2">4</span>
                   <span className="qwerty-1">:</span>
               {"\n"}
              <span className="qwerty-3">        print</span>
                   <span className="qwerty-1">("</span>
                   <span className="qwerty-10">No 4 is continue</span>
                   <span className="qwerty-1">")</span>         
               {"\n"}
                 <span className="qwerty-7">        continue</span>
                 {"\n"}
              <span className="qwerty-3">        print</span>
                   <span className="qwerty-1">("</span>
                   <span className="qwerty-10">This is continue</span>
                   <span className="qwerty-1">")</span>         
               {"\n"}
              <span className="qwerty-3">    print</span>
                   <span className="qwerty-1">(</span>
                   <span className="qwerty-4">i</span>
                   <span className="qwerty-1">)</span>
                 {"\n"}
              <span className="qwerty-3">print</span>
                   <span className="qwerty-1">("</span>
                   <span className="qwerty-10">Complete</span>
                   <span className="qwerty-1">")</span>         
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
               <pre style={{maxHeight:"100vh"}}>
                   <code >
                   {"\n"}
                           <span className="qwerty-3">1</span>
                           {"\n"}    
                           <span className="qwerty-3">2</span>
                           {"\n"}    
                           <span className="qwerty-3">3</span>
                           {"\n"}    
                           <span className="qwerty-4">No 4 is continue</span>
                           {"\n"}    
                           <span className="qwerty-3">5</span>
                           {"\n"}    
                           <span className="qwerty-3">6</span>
                           {"\n"}    
                           <span className="qwerty-3">7</span>
                           {"\n"}    
                           <span className="qwerty-3">8</span>
                           {"\n"}    
                           <span className="qwerty-3">9</span>
                           {"\n"}    
                           <span className="qwerty-3">10</span>
                           {"\n"}    
                           <span className="qwerty-7">Complete</span>
                           {"\n"}    
                           {"\n"}    
                 </code>
                   </pre>
                   </div>  




<h2 className='headings'>Q-Write a program Python loop starts from 1 to 10 and continues at 4 and 8, no?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-7">for</span>
                  <span className="qwerty-4"> i</span>
                  <span className="qwerty-5"> in</span>
                  <span className="qwerty-6"> range</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-2">1</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-2">11</span>
                  <span className="qwerty-1">)</span>
                  <span className="qwerty-1">:</span>
              {"\n"}
              <span className="qwerty-6">    if</span>
                   <span className="qwerty-1"> (</span>
                   <span className="qwerty-4">i</span>
                   <span className="qwerty">==</span>
                   <span className="qwerty-2">4</span>
                   <span className="qwerty-5"> or </span>
                   <span className="qwerty-4"> i</span>
                   <span className="qwerty">==</span>
                   <span className="qwerty-2">8</span>
                   <span className="qwerty-1">)</span>
                   <span className="qwerty-1">:</span>
               {"\n"}
              <span className="qwerty-3">        print</span>
                   <span className="qwerty-1">("</span>
                   <span className="qwerty-10">No is continue</span>
                   <span className="qwerty-1">")</span>         
               {"\n"}
                 <span className="qwerty-7">        continue</span>
                 {"\n"}
              <span className="qwerty-3">        print</span>
                   <span className="qwerty-1">("</span>
                   <span className="qwerty-10">This is continue</span>
                   <span className="qwerty-1">")</span>         
               {"\n"}
              <span className="qwerty-3">    print</span>
                   <span className="qwerty-1">(</span>
                   <span className="qwerty-4">i</span>
                   <span className="qwerty-1">)</span>
                 {"\n"}
              <span className="qwerty-3">print</span>
                   <span className="qwerty-1">("</span>
                   <span className="qwerty-10">Complete</span>
                   <span className="qwerty-1">")</span>         
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
               <pre style={{maxHeight:"100vh"}}>
                   <code >
                   {"\n"}
                           <span className="qwerty-3">1</span>
                           {"\n"}    
                           <span className="qwerty-3">2</span>
                           {"\n"}    
                           <span className="qwerty-3">3</span>
                           {"\n"}    
                           <span className="qwerty-4">No is continue</span>
                           {"\n"}    
                           <span className="qwerty-3">5</span>
                           {"\n"}    
                           <span className="qwerty-3">6</span>
                           {"\n"}    
                           <span className="qwerty-3">7</span>
                           {"\n"}    
                           <span className="qwerty-4">No is continue</span>
                           {"\n"}    
                           <span className="qwerty-3">9</span>
                           {"\n"}    
                           <span className="qwerty-3">10</span>
                           {"\n"}    
                           <span className="qwerty-7">Complete</span>
                           {"\n"}    
                           {"\n"}    
                 </code>
                   </pre>
                   </div> 




<h2 className='headings'>Q-Write a program Loop starts from 1 to 10, but on first even no loop break in Python?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-7">for</span>
                  <span className="qwerty-4"> i</span>
                  <span className="qwerty-5"> in</span>
                  <span className="qwerty-6"> range</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-2">1</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-2">11</span>
                  <span className="qwerty-1">)</span>
                  <span className="qwerty-1">:</span>
              {"\n"}
              <span className="qwerty-6">    if</span>
                   <span className="qwerty-1"> (</span>
                   <span className="qwerty-4">i</span>
                   <span className="qwerty">%</span>
                   <span className="qwerty-8">2</span>
                   <span className="qwerty">==</span>
                   <span className="qwerty-2">0</span>
                   <span className="qwerty-1">)</span>
                   <span className="qwerty-1">:</span>
                   {"\n"}
              <span className="qwerty-3">        print</span>
                   <span className="qwerty-1">("</span>
                   <span className="qwerty-10">Even No</span>
                   <span className="qwerty-1">")</span>
               {"\n"}         
                 <span className="qwerty-7">        continue</span>
                 {"\n"}
              <span className="qwerty-3">    print</span>
                   <span className="qwerty-1">(</span>
                   <span className="qwerty-4">i</span>
                   <span className="qwerty-1">)</span>
                   {"\n"}
              <span className="qwerty-3">print</span>
                   <span className="qwerty-1">("</span>
                   <span className="qwerty-10">Complete</span>
                   <span className="qwerty-1">")</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
               <pre style={{maxHeight:"100vh"}}>
                   <code >
                   {"\n"}
                           <span className="qwerty-3">1</span>
                           {"\n"}    
                           <span className="qwerty-4">Even No</span>
                           {"\n"}    
                           <span className="qwerty-3">3</span>
                           {"\n"}    
                           <span className="qwerty-4">Even No</span>
                           {"\n"}    
                           <span className="qwerty-3">5</span>
                           {"\n"}    
                           <span className="qwerty-4">Even No</span>
                           {"\n"}    
                           <span className="qwerty-3">7</span>
                           {"\n"}    
                           <span className="qwerty-4">Even No</span>
                           {"\n"}    
                           <span className="qwerty-3">9</span>
                           {"\n"}    
                           <span className="qwerty-4">Even No</span>
                           {"\n"}    
                           {"\n"}    
                           <span className="qwerty-7">Complete</span>
                           {"\n"}    
                           {"\n"}    
                 </code>
                   </pre>
                   </div> 

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/python-break">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-lambda">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Pcontinue;